// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css'; 
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

const start = () => {
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// Prerendered pages already contain the full HTML. Let the browser paint it
// first (fast FCP/LCP), then mount React on the next frame. Without this,
// Chrome can run the bundle before the first frame and hold the paint.
if (container.hasChildNodes()) {
  requestAnimationFrame(() => setTimeout(start, 0));
} else {
  start();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
